import { createFileRoute } from "@tanstack/react-router";
import { useTranslation } from "react-i18next";

import Container from "@/components/containers/Container";
import type { ChildRouteContext } from "@/root";
import { throwIfHasNoPermission } from "@/utils/permissions";

import CategoryList from "@/modules/application/admin/components/CategoryList";
import { fetchCategoriesQueryOptions } from "@/modules/application/admin/services";

export const Route = createFileRoute(
  "/admin/_panel/_application/application/categories/",
)({
  beforeLoad: ({ context }) => {
    throwIfHasNoPermission(
      context.user,
      "application.application-category.view",
    );

    return {
      crumb: [
        {
          label: context.t("Manage Categories", { ns: "application.admin" }),
        },
      ],
    } satisfies ChildRouteContext;
  },
  loader: (opts) =>
    opts.context.queryClient.prefetchQuery(fetchCategoriesQueryOptions()),
  component: Component,
});

function Component() {
  const { t } = useTranslation("application.admin");
  return (
    <Container
      title={t("Manage Categories")}
      description={t("Manage, create and edit categories")}
    >
      <CategoryList />
    </Container>
  );
}
